<div class="container-fluid">
  <div class="card">
    <div class="title">
      <div>개인정보 처리 방침</div>
    </div>
    <div class="card-body top">
      <div class="content">{{ privacy }}</div>
    </div>
  </div>
</div>
